/* eslint-disable ember/no-classic-components, ember/require-tagless-components, warp-drive/no-legacy-request-patterns */
// Extends From
import Component from '@ember/component';
import { tracked } from '@glimmer/tracking';
// Ember Imports
import { service } from '@ember/service';
import { action } from '@ember/object';
// Internal Imports

export default class DeleteTemplate extends Component {
  @service
  countdownButton;

  @service
  toaster;

  @tracked
  deleteInProgress = false;
  @tracked
  dialogOpen = false;
  template = null;

  @action
  openDialog() {
    this.dialogOpen = true;
    this.countdownButton.initialise(3);
  }

  @action
  closeDialog() {
    this.dialogOpen = false;
    this.countdownButton.cleanup();
  }

  @action
  delete() {
    this.deleteInProgress = true;
    this.template
      .destroyRecord()
      .then(() => {
        this.toaster.success('template deleted successfully!');
      })
      .catch(() => {
        this.toaster.error('template delete failed!');
      })
      .finally(() => {
        // A successful destroyRecord() removes the template from the
        // store, which immediately tears down this row (and this
        // component) via the list's {{#each}}. This callback can still
        // fire afterward, so guard against setting properties on an
        // already-destroyed component.
        if (this.isDestroying || this.isDestroyed) {
          return;
        }
        this.dialogOpen = false;
        this.deleteInProgress = false;
      });
  }
}
